import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'

import { fetchLogs, getLogs } from '../../../../ducks/logs'

import Card from '../../../Shared/Card'
import { FullScreenLoader } from '../../../Shared/Loading'
import Icon from '../../../Shared/Icon'
import Accordion from '../../../Shared/Accordion'

import EmptyState from './Empty'

import styles from './Logs.module.css'

const ItemDetails = function ItemDetail({ log }) {
  const { inputValues, stepResults } = log

  return (
    <div className={styles.itemDetails}>
      {inputValues.length > 0 && (
        <div className={styles.detailsSection}>
          <h5>Inputs</h5>
          {inputValues.map(({ input, value }) => (
            <p>
              <strong>{input}:</strong> {value}
            </p>
          ))}
        </div>
      )}
      {stepResults.map((step, i) => (
        <div key={step.step && step.step.id} className={styles.detailsSection}>
          <h5>
            Step {i + 1}. {step.label}
          </h5>
          {step.fields &&
            Object.keys(step.fields).map(key => (
              <p>
                <strong>{key}:</strong> {step.fields[key]}
              </p>
            ))}
          {step.error && (
            <div className={styles.error}>
              Error: {step.humanReadableError || step.error}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

const Item = function LogItem({ log }) {
  const icon = log.error ? 'error' : 'checkmark'
  const color = log.error ? 'red' : 'blue'
  const title = log.error ? 'Error' : 'Successful Run'
  const date = moment(log.createdAt)

  return (
    <Accordion
      className={styles.itemWrapper}
      group="logs"
      id={log.id}
      title={
        <div className={styles.item}>
          <Icon icon={icon} color={color} />
          <div className={styles.itemSub}>
            <h3>{title}</h3>
            <p className={styles.metadata}>
              {log.User && <span>{log.User.name}</span>}
              <span title={date.format('llll')}>{date.fromNow()}</span>
            </p>
          </div>
        </div>
      }
    >
      {() => <ItemDetails log={log} />}
    </Accordion>
  )
}

export default function Logs({ match }) {
  const { id: actionId } = match.params
  const dispatch = useDispatch()

  const logs = useSelector(getLogs(actionId))

  useEffect(() => {
    dispatch(fetchLogs(actionId))
  }, [dispatch, actionId])

  if (!logs) {
    return <FullScreenLoader />
  }

  if (logs.length === 0) {
    return <EmptyState id={actionId} />
  }

  return (
    <Card noPad>
      <div className={styles.items}>
        {logs.map(log => (
          <Item key={log.id} log={log} />
        ))}
      </div>
    </Card>
  )
}
